<template>
	<div>
		<q-table
			ref="table"
			:data="enrollments"
			:columns="columns_cancellation_approved"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="requestCancellationApproved"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
			class="q-mt-lg"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="full_name" :props="props">
						{{ props.row.full_name }}
					</q-td>

					<q-td key="code" :props="props">
						{{ props.row.code }}
					</q-td>

					<q-td key="author" :props="props">
						{{ props.row.author }}
					</q-td>

					<q-td key="created_date" :props="props">
						{{ fDate(props.row.created_date) }}
					</q-td>

					<q-td auto-width key="attachments" :props="props">
						<q-btn
							round
							flat
							icon="fas fa-exclamation"
							color="secondary"
							@click="openEvidence(props.row)"
							:disabled="!props.row.attachments.length"
						>
							<q-tooltip>
								{{ $t('show_evidences') }}
							</q-tooltip>
						</q-btn>
					</q-td>

					<q-td key="actions" :props="props">
						<q-btn
							flat
							round
							color="primary"
							icon="fas fa-clipboard-list"
							@click="
								$router.push({
									name: 'appointment',
									params: { id: props.row.presential_event },
								})
							"
						>
							<q-tooltip>
								{{ $t('training') }}
							</q-tooltip>
						</q-btn>
					</q-td>

					<q-td key="observation" :props="props">
						{{ props.row.observation }}
					</q-td>

					<q-td key="justification" :props="props">
						{{ props.row.justification }}
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<q-dialog v-model="attachments_view">
			<span slot="title">{{ $t('evidences') }}</span>

			<div slot="body">
				<q-list dense bordered padding separator class="q-mt-md">
					<q-item v-for="(attachment, index) in attachments_to_view" :key="index">
						<q-item-side icon="fas fa-check" color="positive" />
						<q-item-main>
							<a :href="attachment" class="text-black" target="_blank">
								{{ $truncateLink(attachment) }}</a
							>
						</q-item-main>
					</q-item>
				</q-list>
			</div>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	name: 'AdminEnrollmentCancellationApproved',

	props: ['load'],

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			attachments_view: false,
			attachments_to_view: null,
			enrollments: [],
			columns_cancellation_approved: [
				{
					name: 'full_name',
					required: true,
					label: 'participant',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'code',
					required: true,
					label: 'training_code',
					align: 'left',
					field: 'code',
					sortable: false,
				},
				{
					name: 'author',
					required: true,
					label: 'owner_email',
					align: 'left',
					field: 'author',
					sortable: false,
				},
				{
					name: 'created_date',
					required: true,
					label: 'date',
					align: 'center',
					field: 'created_date',
					sortable: false,
				},
				{
					name: 'attachments',
					required: true,
					label: 'evidences',
					align: 'center',
					field: 'attachments',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'actions',
					sortable: false,
				},
				{
					name: 'observation',
					required: true,
					label: 'motive',
					align: 'left',
					field: 'observation',
					sortable: false,
				},
				{
					name: 'justification',
					required: true,
					label: 'justification',
					align: 'left',
					field: 'justification',
					sortable: false,
				},
			],
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		requestCancellationApproved({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				status: 5,
			}

			this.savePagination()

			this.$axios
				.get(
					`/presential_manager/admin_presential_seats/list_cancellation_enrollment/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.enrollments = response.data.results
						? response.data.results.map((e) => {
								return {
									...e,
									actions: e.presential_event,
								}
						  })
						: []
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		openEvidence(el) {
			this.attachments_to_view = el.attachments.map((e) => e)
			this.attachments_view = true
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.requestCancellationApproved({ pagination: this.server_pagination })
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	mounted() {
		this.loadPagination()
		this.requestCancellationApproved({ pagination: this.server_pagination })
	},
}
</script>

<style></style>
